<template>
  <div class="container">
    <button click=""></button>
  </div>
</template>

<script>
export default {
  name: "Test",
  data() {
    return {};
  },
};
</script>

<style scoped>
.left {
  text-align: left;
}

.smsBtn {
  margin-left: 8px;
}

.container {
  padding-left: 16px;
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/luzhoubank/test_luzhou.vue